module.exports = __webpack_public_path__ + "img/tab-image-child-shopAvatar.e6517bd3.png";